import Vue from 'vue'
import loadZohoSalesIQ from './salesiq.js'
import installGeniusChat from './geniuschat.js'

export default () => {
  const CHAT_MODE = process.env.CHAT_MODE

  let isChatReady = false
  let isChatWindowVisible = false

  let chat

  if (CHAT_MODE === 'salesiq') {
    chat = {
      elementId: 'zsiq_float',
      /**
       * Opens the SalesIQ bubble.
       */
      open: () => {
        if (isChatReady) {
          window.$zoho.salesiq.floatwindow.visible('show')
          isChatWindowVisible = true
        }
      },
      /**
       * Minimizes the SalesIQ bubble.
       */
      minimize: () => {
        if (isChatReady) {
          window.$zoho.salesiq.floatwindow.visible('hide')
          isChatWindowVisible = false
        }
      },
      /**
       * Toggles the visibility of the SalesIQ bubble.
       */
      toggle: () => {
        if (isChatReady) {
          if (isChatWindowVisible) {
            window.$zoho.salesiq.floatwindow.visible('hide')
            isChatWindowVisible = false
          } else {
            window.$zoho.salesiq.floatwindow.visible('show')
            isChatWindowVisible = true
          }
        }
      },
      /**
       * Displays the chat button.
       */
      displayChat: () => {
        if (isChatReady) {
          window.$zoho.salesiq.floatbutton.visible('show')
        }
      },
      /**
       * Hides the chat button and bubble.
       */
      hideChat: () => {
        if (isChatReady) {
          window.$zoho.salesiq.floatwindow.visible('hide')
          window.$zoho.salesiq.floatbutton.visible('hide')
          isChatWindowVisible = false
        }
      },

      /**
       * Sets the user information in SalesIQ.
       * @param {object} user - Information about the user.
       * @param {string} user.email - The email of the user.
       * @param {string} user.name - The full name of the user.
       * @param {string} user.phone - The contact number of the user.
       */
      setUser: user => {
        if (isChatReady) {
          window.$zoho.salesiq.visitor.email(user.email)
          window.$zoho.salesiq.visitor.name(user.name)
          window.$zoho.salesiq.visitor.contactnumber(user.phone)
        }
      }
    }

    // Load SalesIQ script
    loadZohoSalesIQ(() => {
      // Hide widget on load
      window.$zoho.salesiq.floatbutton.visible('hide')
      window.$zoho.salesiq.floatwindow.visible('hide')
      isChatWindowVisible = false

      // Update visibility tracking if user manually closes the widget
      window.$zoho.salesiq.floatwindow.minimize(() => {
        isChatWindowVisible = false
      })

      isChatReady = true
      chat.hideChat()
    })
  } else if (CHAT_MODE === 'geniuschat') {
    chat = {
      elementId: 'genius-chat-widget',
      /**
       * Opens the GeniusChat window.
       */
      open: () => {
        window.GeniusChat?.setChromeVisible(true)
        window.GeniusChat?.open()
        isChatWindowVisible = true
      },
      /**
       * Minimizes the GeniusChat window.
       */
      minimize: () => {
        window.GeniusChat?.close()
        isChatWindowVisible = false
      },
      /**
       * Toggles the visibility of the GeniusChat window.
       */
      toggle: () => {
        if (isChatWindowVisible) {
          chat.minimize()
        } else {
          chat.open()
        }
      },
      /**
       * Displays the chat button.
       */
      displayChat: () => {
        window.GeniusChat?.setChromeVisible(true)
      },
      /**
       * Hides the chat button and window.
       */
      hideChat: () => {
        window.GeniusChat?.close()
        window.GeniusChat?.setChromeVisible(false)
        isChatWindowVisible = false
      },
      /**
       * User identity is passed to GeniusChat via the session token during
       * load, so this is a no-op kept for interface parity with other clients.
       */
      setUser: () => {}
    }

    // Load GeniusChat script (boots hidden).
    installGeniusChat(() => {
      isChatReady = true
      chat.hideChat()
    })
  }

  // No recognized CHAT_MODE means no chat client is loaded.
  if (chat) {
    Vue.prototype.$chat = chat
  }
}
